import React from "react";

const API_URL = 'https://api.talentpedia.digitalnoticeboard.biz/api'
//const API_URL = 'http://127.0.0.1:8000/api'


export { API_URL }